import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/analytics-1.4-apis/analytics-1.4-apis/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started-with-the-analytics-api"
    }}>{`Getting started with the Analytics API`}</h1>
    <p>{`Before using the Analytics 1.4 APIs, follow these steps:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Permissions`}</strong>{`: Configure permissions for the developer in the Adobe Admin Console.`}</li>
      <li parentName="ul"><strong parentName="li">{`API Client`}</strong>{`: Create a client configuration in the Adobe Developer Console.`}</li>
      <li parentName="ul"><strong parentName="li">{`Authentication`}</strong>{`: Obtain the necessary credentials to send data to Adobe.`}</li>
    </ul>
    <h2 {...{
      "id": "permissions"
    }}>{`Permissions`}</h2>
    <p>{`Before starting to use the Analytics API, you must make sure that your account has the correct permissions to send requests. Even if you successfully authenticate with an Adobe ID, you cannot make requests to Adobe unless your account contains the correct organization permissions.`}</p>
    <p>{`Give a developer correct API permissions as a product profile admin:`}</p>
    <ol>
      <li parentName="ol">{`Navigate to `}<a parentName="li" {...{
          "href": "https://adminconsole.adobe.com"
        }}>{`adminconsole.adobe.com`}</a>{`.`}</li>
      <li parentName="ol">{`Check the organization name in the top right to make sure that you are logged in to the correct company.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Products`}</strong>{`, then click `}<strong parentName="li">{`Adobe Analytics`}</strong>{`.`}</li>
      <li parentName="ol">{`Select the desired product profile, or create a new product profile.`}</li>
      <li parentName="ol">{`Under the Permissions tab, assign the desired permissions to the product profile.`}</li>
      <li parentName="ol">{`Once the desired permissions are set, click the Developers tab.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Add Developer`}</strong>{`, and enter the user name or email address that you want to assign the permissions to.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Save`}</strong>{`.`}</li>
    </ol>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://helpx.adobe.com/enterprise/using/manage-developers.html"
      }}>{`Managing developers`}</a>{` in the Enterprise Admin user guide for more information.`}</p>
    <h2 {...{
      "id": "api-client"
    }}>{`API Client`}</h2>
    <p>{`Once you are a developer for an Analytics product profile, you can create an API client in the Adobe Developer Console.`}</p>
    <ol>
      <li parentName="ol">{`Navigate to `}<a parentName="li" {...{
          "href": "https://console.adobe.io"
        }}>{`console.adobe.io`}</a>{`.`}</li>
      <li parentName="ol">{`Check the organization name in the top right to make sure that you are logged in to the correct company.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Create new project`}</strong>{`.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Add API`}</strong>{`.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Adobe Analytics`}</strong>{`, then click `}<strong parentName="li">{`Next`}</strong>{`.`}</li>
    </ol>
    <p>{`At this point, you decide how you want to authenticate with the API.`}</p>
    <h2 {...{
      "id": "authentication"
    }}>{`Authentication`}</h2>
    <p>{`Adobe offers two primary methods to authenticate:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`OAuth User`}</strong>{`: Use your own account to authenticate with the API. See `}<a parentName="p" {...{
            "href": "https://developer.adobe.com/developer-console/docs/guides/authentication/UserAuthentication/"
          }}>{`OAuth User Authentication`}</a>{` in the Adobe Developer Authentication user guide.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`OAuth Server to Server`}</strong>{`: Use a server-to-server account to authenticate with the API. See `}<a parentName="p" {...{
            "href": "https://developer.adobe.com/developer-console/docs/guides/authentication/ServerToServerAuthentication/"
          }}>{`OAuth Server to Server Authentication`}</a>{` in the Adobe Developer Authentication user guide.`}</p>
      </li>
    </ul>
    <p>{`Choose your desired authentication method, and complete any remaining steps to finish the API client wizard, as described in the previous section.`}</p>
    <p>{`JWT authentication is deprecated and will only be supported until January 1, 2025. Current integrations using JWT will need to `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/developer-console/docs/guides/authentication/ServerToServerAuthentication/migration/"
      }}>{`migrate`}</a>{` to OAuth Server to Server prior to January 1, 2025. `}</p>
    <p>{`To refresh authentication tokens, see the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/developer-console/docs/guides/authentication/UserAuthentication/IMS/#refreshing-access-tokens"
      }}>{`Authentication Guide`}</a>{`.`}</p>
    <p>{`JWT authentication is deprecated and will only be supported until January 1, 2025. Current integrations using JWT will need to `}{`[migrate]`}{`(`}<a parentName="p" {...{
        "href": "https://developer.adobe.com/developer"
      }}>{`https://developer.adobe.com/developer`}</a>{` console/docs/guides/authentication/ServerToServerAuthentication/migration/) to OAuth Server to Server prior to January 1, 2025.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      